import { LegalPoliciesLinks } from "./LegalPoliciesLinks";

const Footer = () => {
  return (
    <footer className="flex justify-center py-2 backdrop-blur border-gray-500 bg-card/50">
      <LegalPoliciesLinks
        variant="footer"
        showCopyright
        className="w-full md:w-[85%]"
      />
    </footer>
  );
};

export default Footer;
